import { useNavigate } from '@tanstack/react-router';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useAwardEdit } from '@/module/Author/Award/model/AwardQuery';
import { AwardSchema, awardSchema, defaultAwardValues } from '@/module/Author/Award/model/AwardSchema';

import { useAppNotification } from '@feature/utils';

import { AwardForm } from './AwardForm';
import { Award } from './model/AwardTypes';

interface AwardEditProps {
  award: Award;
}

const convert = (award: Award): AwardSchema => ({
  ...award,
});

export function AwardEdit(props: AwardEditProps) {
  const { award } = props;
  const { t } = useTranslation();
  const { mutate, isPending, isError, isSuccess } = useAwardEdit(award.id);

  const notification = useAppNotification();
  const onSubmit = (values: AwardSchema) => {
    mutate(values, {
      onError: notification.error,
      onSuccess: notification.success,
    });
  };

  const values = useMemo(() => convert(award), [award]);
  const navigate = useNavigate();

  return (
    <AwardForm
      title={t('awards.form.title.edit')}
      schema={awardSchema}
      defaultValues={defaultAwardValues}
      isError={isError}
      isSuccess={isSuccess}
      values={values}
      onSubmit={onSubmit}
      isSubmitting={isPending}
      onCancel={() => navigate({ to: '..' })}
    />
  );
}
